/*eslint no-var: [2] */
import PropTypes from 'prop-types';

import React from 'react';
import Note from './chapter/note.jsx';

export default class Chapter extends React.PureComponent {
    static displayName = 'Chapter';

    static propTypes = {
        addTag: PropTypes.func.isRequired,
        allPages: PropTypes.object.isRequired,
        chapter: PropTypes.object.isRequired,
    };

    renderNotes = () => {
        const { allPages } = this.props;
        return this.props.chapter.notes.map(note => {
            return (
                <Note
                    addTag={this.props.addTag}
                    key={note.cid}
                    pageLabel={allPages[note.page]}
                    note={note}
                />
            );
        });
    };

    render() {
        const { chapter } = this.props;
        const notes = chapter.notes;

        if (notes.length === 0) {
            return null;
        }

        return (
            <div>
                <h3>
                    <span className="aural">{notes.length} notes in </span>
                    {chapter.name}
                    <span className="aural" aria-hidden>
                        {notes.length} Notes
                    </span>
                </h3>
                <div className="js-notes">{this.renderNotes()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/all_notes/chapter.jsx